import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import BrandLogo from "@/components/BrandLogo";

export default function CourseStoreHeader({ onBack, showBackButton = false, selectedCourse = null }) {
  return (
    <header className="w-full bg-background/80 backdrop-blur-md border-b border-border py-4 px-6 md:px-12 flex items-center justify-between sticky top-0 z-50">
      <div
        className="flex items-center cursor-pointer"
        onClick={onBack}
      >
        <BrandLogo alt="Institute logo" className="h-10 w-auto" />
      </div>
      {!selectedCourse && (
        <div className="hidden md:flex gap-4">
          <Button
            onClick={() => window.location.href = '/login'}
            variant="ghost"
            className="px-5 py-2 text-sm font-semibold"
          >
            Login
          </Button>
          <Button
            onClick={() => window.location.href = '/login'}
            className="px-5 py-2 text-sm font-semibold"
          >
            Get Started
          </Button>
        </div>
      )}
    </header>
  );
}
